module.exports = __webpack_public_path__ + "img/install_anno@3x.4d8665c8.png";